import { useEffect } from 'react';

export function GlobalThemeStyles() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      /* Override inline styles with !important */
      .theme-light [style*="background-color: rgb(10, 10, 10)"],
      .theme-light [style*="backgroundColor: '#0a0a0a'"] {
        background-color: #E5C687 !important;
      }
      
      .theme-light [style*="background-color: rgb(26, 26, 26)"],
      .theme-light [style*="backgroundColor: '#1a1a1a'"] {
        background-color: #B98241 !important;
      }
      
      .theme-light [style*="background-color: rgb(42, 42, 42)"],
      .theme-light [style*="backgroundColor: '#2a2a2a'"] {
        background-color: #936027 !important;
      }
      
      .theme-light [style*="color: rgb(229, 229, 229)"],
      .theme-light [style*="color: '#e5e5e5'"] {
        color: #1A1A1A !important;
      }
      
      .theme-light [style*="color: rgb(136, 136, 136)"],
      .theme-light [style*="color: '#888'"] {
        color: #3B2E19 !important;
      }
      
      .theme-light [style*="color: rgb(0, 212, 170)"],
      .theme-light [style*="color: '#00d4aa'"] {
        color: #7E8332 !important;
      }
      
      .theme-light [style*="border"],
      .theme-light [style*="borderColor: '#333'"] {
        border-color: #2C3E50 !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return null;
}